import type { DocumentTableRow } from 'features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns'

import type { CardFilterValues } from './types'
import { FILTER_FIELDS } from './types'

export function applyCardFilters(
  documents: DocumentTableRow[],
  filters: CardFilterValues
): DocumentTableRow[] {
  const matchers: ((doc: DocumentTableRow) => boolean)[] = []

  for (const field of FILTER_FIELDS) {
    const filterValue = filters[field.id]
    if (!filterValue) continue

    if (
      field.type === 'text' &&
      typeof filterValue === 'string' &&
      filterValue.length > 0
    ) {
      const lower = filterValue.toLowerCase()
      const { accessor } = field
      matchers.push((doc) => {
        const dv = accessor(doc)
        return (
          dv !== null && dv !== undefined && dv.toLowerCase().includes(lower)
        )
      })
    }

    if (
      field.type === 'multiselect' &&
      Array.isArray(filterValue) &&
      filterValue.length > 0
    ) {
      const allowed = new Set(filterValue)
      const { accessor } = field
      matchers.push((doc) => {
        const dv = accessor(doc)
        return dv !== null && dv !== undefined && allowed.has(dv)
      })
    }
  }

  if (matchers.length === 0) return documents
  return documents.filter((doc) => matchers.every((m) => m(doc)))
}
